const axios = require('axios').default
const realLog = (e) => ({}) //console.log
/**
 * sso.js
 * wrapper utk manggil sso jasny
 * real file ada di /static/sso/api.php
 */

class SSO {
	defaultName

    //  constructor does nothing I guess
    constructor(cookieName, attachOnInit) {
        // init variables
        this.attached = false
		this.defaultName = cookieName
		this.attaching = false
		this.bearerToken = ''

        // maybe do some attachment when started?
        try {
            // await on ajax request (serialize it)
            if (attachOnInit) {
                this.attach(cookieName)
            }
        } catch (e) {
            realLog('FAILED ATTACHING SSO SESSION')
			realLog(e)
        }
    }

	// verify here
	async verify(data) {
		// let tokenName = 'sso_token_' + cookieName
		// let verifyName = 'sso_verify_' + cookieName

		// const cookie = require('cookie')

		realLog(`SSO verify cookie:`, data)

		// just call verify
		try {
			var fd = new FormData()
			fd.set('verify', data)

			var ret = await axios({
				method: 'post',
				url: '/static/sso/verify.php',
				data: fd,
				config: {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			})

			realLog(`SSO_VERIFY_RESULT: `, ret)
			this.attached = true

			return ret
		} catch (error) {
			realLog('SSO_TOKEN_VERIFY_FAILED', error)
		}

		return false
	}

	// grab token
	async grabToken() {
		// now we grab our token
		try {
			var tokenData = await axios({
				method: 'get',
				url: '/static/sso/token.php'
			})

			realLog(`SSO_TOKEN: `, tokenData)

			this.bearerToken = tokenData.data.token

			return this.bearerToken;
		} catch (error) {
			console.log(`FAILED_GRAB_TOKEN: `, error)
			return null
		}
	}

    // attach, make it async
    async attach(cookieName) {
		if (this.attaching || this.attached) {
			if (this.attaching) {
				realLog(`SKIPPED: ALREADY ATTACHING...`)
			}
			if (this.attached) {
				realLog(`SKIPPED: ALREADY ATTACHED.`)
			}
			return
		}

		// flag as attaching
		this.attaching = true

		try {
			var ret = await $.ajax({
				url: '/static/sso/attach.php',
				crossDomain: true,
				dataType: 'jsonp'
			})

			realLog(`SSO_ATTACH_RETURN_DATA`, ret)

			if (ret.verify) {
				realLog(`SSO_CAN_VERIFY: `, ret.verify)
				ret = await this.verify(ret.verify)
				// grab token after verify
				await this.grabToken()
			}

			// perhaps already attached?
			if (ret.code == '400' && ret.message == 'Token is already attached') {
				console.log(`SSO_TOKEN_ALREADY_ATTAHCED!`)
				this.attached = true
				// no need to verify, just grab token
				await this.grabToken()
			}

			// flag as not attaching
			this.attaching = false

			return ret
		} catch (e) {
			realLog(`SSO_ATTACH_ERROR:`, e)
			this.attaching = false
		}

		return null
    }

	// spin wait
	spinWait(maxTries) {
		maxTries = maxTries || 100
		console.log(`spinWaiting until maxtries: ${maxTries} attempted...`)

		const me = this
		var timer = 0
		var tries = 0

		return new Promise((resolve, reject) => {

			function wait() {
				// if we're still attaching and has not yet attached
				if (me.attaching && !me.attached) {
					console.log(`spinWait: tries ${tries}`)
					tries++

					if (tries > maxTries) {
						console.log(`spinWait killed @ tries ${tries}, maxtries: ${maxTries}`)
						clearTimeout(timer)
						reject(new Error('spinWait maxtries exceeded!'))
					} else {
						// delete this timer, and start a new one
						if (timer) clearTimeout(timer)
						timer = setTimeout(wait, 1000)
					}
				} else if (me.attached || !me.attaching) {
					console.log(`spinWait over @ ${tries}`)
					clearTimeout(timer)
					resolve(true)
				}
			}

			wait()
		})
	}

    // just login
    login(username, password) {
        const fd = new FormData()

        fd.set('username', username)
        fd.set('password', password)

        return axios({
            method: 'post',
            url: '/static/sso/api.php?command=login',
            data: fd,
            config: {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        })
    }

    // logout using post
    logout() {
		this.attached = false	// force renewal of token
    	return axios({
            method: 'post',
			data: {},
			url: '/static/sso/logout.php'
            //url: '/static/sso/api.php?command=logout'
        })
    }

    // get user info
    getUserInfo() {
        return axios({
            method: 'get',
            url: '/static/sso/api.php?command=info'
        })
    }
}

//  export list
export {
    SSO
}



// WEBPACK FOOTER //
// ./src/libs/sso.js